/* eslint-disable no-underscore-dangle */
import { getLogLevel } from 'Utils/features';
import { isProd } from 'Utils/env';
import DatadogAdapter from './adapters/DatadogAdapter';
import ConsoleAdapter from './adapters/ConsoleAdapter';
import { LoggerService } from './LoggerService';

const appLogLevel = getLogLevel();

const currentAdapters = [DatadogAdapter];

if (!isProd()) {
  currentAdapters.push(ConsoleAdapter);
}

export default class LoggerFactory {
    static _loggersByDomain: Record<string, LoggerService> = {};

    static getLogger(domain = 'default'): LoggerService {
      if (!LoggerFactory._loggersByDomain[domain]) {
        const domainName: string | undefined = domain !== 'default' ? domain : undefined;
        const logger = new LoggerService(appLogLevel, domainName);
        logger.addAdapters(...currentAdapters);
        this._loggersByDomain[domain] = logger;
      }

      return this._loggersByDomain[domain];
    }
}
